import { Link } from "react-router-dom";

import logoSmall from "../../../../assets/images/logo/logo-minimalist.png";
import logoSmallDark from "../../../../assets/images/logo/logo-minimalist.png";
import logo from "../../../../assets/images/logo/logo-light.png";
import logoDark from "../../../../assets/images/logo/logo-dark.png";
import logoRTL from "../../../../assets/images/logo/logo-light.png";
import logoRTLDark from "../../../../assets/images/logo/logo-dark.png";

import { useCustomise } from "../../../../context/customiseContext";

export default function MenuLogo(props) {
  const {theme, direction} = useCustomise();

  return (
    <div className="hp-header-logo hp-d-flex hp-align-items-center">
      <Link
        to="/"
        onClick={props.onClose}
        className="hp-position-relative hp-d-flex"
      >
        {props.small ? (
          theme === "light" ? (
            <img className="hp-logo" src={logoSmall} alt="logo" />
          ) : (
            <img className="hp-logo" src={logoSmallDark} alt="logo" />
          )
        ) : direction === "rtl" ? (
          theme === "light" ? (
            <img className="hp-logo" src={logoRTL} alt="logo" />
          ) : (
            <img className="hp-logo" src={logoRTLDark} alt="logo" />
          )
        ) : theme === "light" ? (
          <img className="hp-logo" src={logo} alt="logo" />
        ) : (
          <img className="hp-logo" src={logoDark} alt="logo" />
        )}
      </Link>
    </div>
  );
}
